import React from 'react';
import { Shield } from 'lucide-react';
import Header from './components/Header9';
import Footer from './components/Footer9';

const PrivacyPolicy = () => {
    const sections = [
        {
            title: '1. Information We Collect',
            content: 'We collect information that you provide directly to us, including your name, email address, postal address, phone number, and payment information when you make a purchase, create an account, subscribe to our newsletter, or contact us. We also automatically collect certain information about your device when you use our website, including your IP address, browser type, operating system, and browsing behavior.'
        },
        {
            title: '2. How We Use Your Information',
            content: 'We use the information we collect to process your orders and payments, send order confirmations and shipping updates, provide customer support, personalize your shopping experience, send marketing communications (with your consent), improve our website and services, prevent fraud and maintain security, and comply with legal obligations.'
        },
        {
            title: '3. Information Sharing',
            content: 'We do not sell your personal information to third parties. We may share your information with trusted service providers who assist us in operating our website, processing payments, and delivering orders. These providers are contractually obligated to keep your information confidential and secure.'
        },
        {
            title: '4. Data Security',
            content: 'We implement industry-standard security measures to protect your personal information, including 256-bit SSL encryption for all data transmissions, secure payment processing through certified payment gateways, regular security audits and vulnerability assessments, and restricted access to personal information within our organization.'
        },
        {
            title: '5. Cookies and Tracking',
            content: 'Our website uses cookies and similar tracking technologies to enhance your browsing experience. Essential cookies are required for the website to function properly. Analytics cookies help us understand how visitors interact with our website. Marketing cookies are used to deliver relevant advertisements. You can control cookie preferences through your browser settings.'
        },
        {
            title: '6. Your Rights',
            content: 'You have the right to access, correct, or delete your personal information. You can update your account information at any time through your profile settings. To request data deletion or a copy of your data, contact us at privacy@naksha.in. We will respond to all requests within 30 days.'
        },
        {
            title: '7. Data Retention',
            content: 'We retain your personal information for as long as your account is active or as needed to provide you services. We will retain and use your information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements.'
        },
        {
            title: '8. Changes to This Policy',
            content: 'We may update this privacy policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "Last updated" date. We encourage you to review this policy periodically for any changes.'
        },
    ];

    return (
        <div className="w-full min-h-screen bg-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <div className="pt-20 md:pt-24 pb-8 bg-[#F8FAFC] border-b border-[#E2E8F0]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-0.5 bg-[#2563EB]" />
                        <p className="text-xs tracking-[0.3em] uppercase text-[#2563EB] font-medium">Legal</p>
                    </div>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A]">Privacy Policy</h1>
                    <p className="text-sm text-[#64748B] mt-3 font-light">Last updated: March 1, 2026</p>
                </div>
            </div>

            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                <div className="p-6 bg-[#F8FAFC] border border-[#E2E8F0] rounded-none mb-10">
                    <div className="flex items-start gap-3">
                        <Shield size={20} className="text-[#2563EB] flex-shrink-0 mt-0.5" />
                        <p className="text-sm text-[#64748B] font-light leading-relaxed">
                            At NAKSHA, we take your privacy seriously. This policy describes how we collect, use, and protect your personal information when you use our website and services.
                        </p>
                    </div>
                </div>

                <div className="space-y-8">
                    {sections.map((section, index) => (
                        <div key={index} className="border-l-2 border-[#E2E8F0] pl-6 hover:border-[#2563EB] transition-colors duration-300">
                            <h2 className="text-base sm:text-lg font-semibold text-[#0F172A] mb-3">{section.title}</h2>
                            <p className="text-sm text-[#64748B] leading-relaxed font-light">{section.content}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-12 p-6 bg-[#F8FAFC] border border-[#E2E8F0] rounded-none">
                    <p className="text-sm font-medium text-[#0F172A] mb-1">Privacy concerns?</p>
                    <p className="text-sm text-[#64748B] font-light">
                        Contact our privacy team at{' '}
                        <a href="mailto:privacy@naksha.in" className="text-[#2563EB] hover:text-[#1D4ED8]">privacy@naksha.in</a>
                    </p>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
